import React, { useState } from 'react'
import PageHeading from '../../../components/PageHeading'
import FilterTable from '../../../components/FilterTable'
import { Link } from 'react-router-dom'

export default function LandOwnerReimbursementTable() {
    let [investorList, setInvestorList] = useState([])
    let [investorTempList, setInvestorTempList] = useState([
        {
            name:"",
            projectname:"",
            khashra:"",
            amount:"0",
        },
        {
            name:"",
            projectname:"",
            khashra:"",
            amount:"0",
        },
        {
            name:"",
            projectname:"",
            khashra:"",
            amount:"0",
        },
        
       
        
    ])
    let [loader, setLoader] = useState(1)

    let [sideToster, setSideToster] = useState({
        show: 0,
        message: '',
        type: ''
    })
    return (
        <>
            <div className='container-fluid landformconatiner p-4'>
                <div className='d-flex flex-column flex-md-row justify-content-between'>
                    <PageHeading pagename="Land Owner Reimbursement" />
                    <FilterTable tempList={investorTempList} tempListMethod={setInvestorTempList} originalList={investorList} isSearch={false} isdate={false} isFilter={false} isExport={false} />
                </div>
                <div className='pt-4'>
                    <table class="table">
                        <thead>
                            <tr className='table-head'>
                                {/* <th scope="col">#</th> */}
                                {/* <th scope="col">State</th> */}
                                <th scope="col">Name</th>
                                <th scope="col">Project Name</th>
                                <th scope="col">Khashra</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            {
                                investorTempList && investorTempList.map((val, ind) => {
                                    return (
                                        <tr >
                                            {/* <th scope="row">{ind + 1}</th> */}
                                            <td>
                                                <div className='d-flex flex-row gap-2'>
                                                    <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                    <span className='d-flex flex-column gap-1'>
                                                        <label className='heading-project fw-semibold'>{val.name}</label>
                                                        {/* <label className='sub-heading-project' style={{ color: "#737791" }}>Ownership {val.percentage}%</label> */}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>{val.projectname}</td>
                                            <td>{val.khashra}</td>
                                            <td>{val.amount}</td>
                                            <td >
                                                <div class="dropdown dropend">
                                                    <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                    <ul className="dropdown-menu mr-3">
                                                        {
                                                            val.investorType === 1 ?
                                                                <li><Link className="dropdown-item" to={`/viewprofilecompany/${val.id}`}>View Details</Link></li>
                                                                :
                                                                <li><Link className="dropdown-item" to={`/viewprofileinvestor/${val.id}`}>View Details</Link></li>

                                                        }
                                                        {/* <li><span className="dropdown-item" onClick={() => { handleDelete(val.id) }}>Delete</span></li> */}
                                                        {/* <li onClick={handleLogout}><Link className="dropdown-item" href="#">Logout <i className="bi bi-box-arrow-right"></i></Link></li> */}
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }



                        </tbody>
                    </table>
                </div>


            </div>
        </>
    )
}
